import React, {useEffect, useState} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Api from "../../../../interface/api/content/terms"
import {ManagementMenuOptionItem, ManagementMenuOptionItem2} from "../../../../component/menu-item";
import { TermsInfoDTO, createTermsInfoDTO } from '../../../../interface/model/terms';
import { Pagination } from "../../../../component/paging";
import { Page } from "../../../../interface/model/page";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";

export default function TermsManage() {
    const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
    const [ selectedTermsInfo, setSelectedTermsInfo ] = useState<TermsInfoDTO>(null);
    const [ termsInfos, setTermsInfos ] = useState<Page>();
    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ searchInfo , setSearchInfo ] = useState({
        boardSearchType : 'all',
        searchValue : ''
    });

    function modifyHandler(boardInfo) {
        setSelectedTermsInfo(boardInfo);
    }

    function deleteHandler(seq) {
        Api.deleteTermsInfo(seq);
    }

    function modeHandler(boardInfo) {
        setSelectedTermsInfo(boardInfo);
    }

    function insertHandler() {
        if( selectedTermsInfo.termsInfoSeq !== null ) {
            Api.updateTermsInfo(siteInfo.seq, selectedTermsInfo).then(res=> {
                alert('정상적으로 처리되었습니다.');
                Api.searchTermsInfos(siteInfo.seq, searchInfo, pageNumber).then(res => {
                    setTermsInfos(res.data);
                    modeHandler(null)
                });
            })
        }

        else Api.createTermsInfo(siteInfo.seq, selectedTermsInfo).then(r => {
            alert('정상적으로 처리되었습니다.');
            Api.searchTermsInfos(siteInfo.seq, searchInfo, pageNumber).then(res => {
                setTermsInfos(res.data);
                modeHandler(null)
            });
        });
    }

    useEffect(() => {
        Api.searchTermsInfos(siteInfo.seq, searchInfo, pageNumber).then(res => setTermsInfos(res.data));
    }, [])

    return (
        <>
            <div className="nv_contents">
                {
                    selectedTermsInfo !== null
                        ? <>
                            <Detail selectedTermsInfo={selectedTermsInfo} setSelectedTermsInfo={setSelectedTermsInfo} />
                            <div className="btn_area nv_page_bottomarea_type2">
                                <button type="button" className="nv_green_button m_w_100" style={{marginLeft:'5px'}} onClick={() => modeHandler(null)}>취소</button>
                                <button type="button" className="nv_blue_button m_w_100" onClick={insertHandler}>저장</button>
                            </div>
                        </>
                        : <>
                            <List siteInfo = { siteInfo }
                                  termsInfos = { termsInfos }
                                  setTermsInfos = { setTermsInfos }
                                  searchInfo = { searchInfo }
                                  setSearchInfo = { setSearchInfo }
                                  pageNumber = { pageNumber }
                                  modifyHandler = { modifyHandler }
                                  deleteHandler = { deleteHandler } />
                            <div className="nv_table_box nv_m_btn_area nv_bord_btn_area">
                                <button type="button" className="nv_blue_button right"
                                        onClick={() => modeHandler(createTermsInfoDTO)}>작성
                                </button>
                            </div>
                        </>
                }
            </div>
        </>
    )
}

function List({ siteInfo, termsInfos, setTermsInfos , searchInfo,  setSearchInfo, pageNumber, modifyHandler, deleteHandler}) {
    function searchHandler() {
        if(searchInfo.searchValue !== '') {
            const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
            Api.searchTermsInfos(siteInfo.seq, searchInfo, pageNumber).then(res => setTermsInfos(res.data));
        }
    }

    function pageMoveHandler(pageNumber) {
        Api.searchTermsInfos(siteInfo.seq, searchInfo, pageNumber).then(res => setTermsInfos(res.data));
    }

    function submit(e) {
        e.preventDefault();
        searchHandler();
    }


    return (
        <>
            <form onSubmit={submit}>
                <div className="nv_contents_search">
                    <div className="nv_select_box">
                        <p id="conditionKey">
                            {searchInfo.boardSearchType == 'all' && '전체'}
                            {searchInfo.boardSearchType == 'title' && '제목'}
                            {searchInfo.boardSearchType == 'contents' && '내용'}
                        </p>
                        <ul>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'all'})}>전체</li>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'title'})}>제목</li>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'contents'})}>내용</li>
                        </ul>
                    </div>
                    <div className="nv_search_box">
                        <input type="text" className="nv_input" id="conditionValue" title="Search" onChange={(e) => setSearchInfo({...searchInfo, searchValue: e.target.value})}/>
                        <input type="submit" className="nv_search_icon tpc_skip m_skip" title="search"/>
                    </div>
                    <div className="nv_search_box pc_skip tpc_skip" style={{width:"32px;"}}>
                        <input type="submit" className="nv_search_icon" title="search"/>
                    </div>
                </div>
            </form>
            <div className="nv_table_box">
                <TableContainer component={Paper}>
                    <table className="nv_table textcenter" id="termsTable">
                        <colgroup>
                            <col style={{width: '70%'}}/>
                            <col style={{width: '15%'}}/>
                            <col style={{width: '15%'}}/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th scope="row">명칭</th>
                            <th scope="row">필수여부</th>
                            <th scope="row">관리</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            termsInfos !== undefined && termsInfos.content.length > 0
                                ? termsInfos.content.map((termsInfo, index) => (
                                <tr key={`termsInfoKey-${index}`}>
                                    <td>
                                        {termsInfo.title}
                                    </td>
                                    <td>
                                        {termsInfo.requiredFlag ? "필수" : "선택"}
                                    </td>
                                    <td>
                                        <ManagementMenuOptionItem items={[
                                            {
                                                innerHTML:'수정',
                                                onClickHandler:() => modifyHandler(termsInfo)
                                            },
                                            {
                                                innerHTML:'삭제',
                                                onClickHandler:() => deleteHandler(termsInfo.boardInfoSeq)
                                            }
                                        ]}/>
                                    </td>
                                </tr>
                            ))
                                :<tr>
                                    <td colSpan={3}>등록된 서약서가 존재하지 않습니다.</td>
                                </tr>
                        }
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </TableContainer>
                <div className="nv_table_pagenum" id="pagenation">
                    <Pagination page={ termsInfos } pageMoveHandler={ pageMoveHandler } />
                </div>
            </div>
        </>
    )
}
function Detail({selectedTermsInfo, setSelectedTermsInfo}) {
    const modules = {
        toolbar: [
            //[{ 'font': [] }],
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image'],
            [{ 'align': [] }, { 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            ['clean']
        ],
    }

    const formats = [
        //'font',
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image',
        'align', 'color', 'background',
    ]
    return (
        <>
            <div className="nv_table_tit regist_tit">
                <h4>서약서 작성</h4>
            </div>
            <div className="nv_table_box nv_table_scroll">
                <table className="nv_table nv_write_table">
                    <colgroup>
                        <col width={'20%'}/>
                        <col/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>제목</td>
                        <td>
                            { selectedTermsInfo.title != null ?
                                <input type="text" className="nv_input" value={selectedTermsInfo.title} style={{width: '80%'}} onChange={(e) => setSelectedTermsInfo({...selectedTermsInfo, title:e.target.value})} /> :
                                <input type="text" className="nv_input" placeholder="서약서 제목을 입력해주세요." style={{width: '80%'}} onChange={(e) => setSelectedTermsInfo({...selectedTermsInfo, title:e.target.value})} /> }
                        </td>
                    </tr>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>필수여부</td>
                        <td>
                            <input type="checkbox" id="requiredCheck" checked={selectedTermsInfo.requiredFlag} onChange={(e) => setSelectedTermsInfo({...selectedTermsInfo, requiredFlag:e.target.checked})} />
                        </td>
                    </tr>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>내용</td>
                        <td>
                            <ReactQuill style={{width : '100%', height: "350px", overflow:'auto', listStyle:'none'}}
                                        modules={modules}
                                        formats={formats}
                                        value={selectedTermsInfo.contents || ''}
                                        onChange={(content, delta, source, editor) => setSelectedTermsInfo({...selectedTermsInfo, contents : editor.getHTML()})}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}